import Head from "next/head";

const CLARITY_PROJECT_ID = "ycbk4ykyhm";

/**
 * Microsoft Clarity tracking code.
 * Enables heatmaps & session recordings on pages where this component is
 * rendered (currently all reseller-related public pages).
 * Injected into the document <head> via next/head.
 */
export default function ClarityTracking() {
  return (
    <Head>
      <script
        type="text/javascript"
        dangerouslySetInnerHTML={{
          __html: `
            (function(c,l,a,r,i,t,y){
              c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
              t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
              y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "${CLARITY_PROJECT_ID}");
          `,
        }}
      />
    </Head>
  );
}
